import fileDownload from 'js-file-download';

const BASE_URL = process.env.NODE_ENV !== 'production'
  ? 'http://localhost:3001'
  : 'https://sideop-file-server.hermosillo.gob.mx';

export default {
  methods: {
    mixDescargar() {
      // console.log('descargas Mix');
    },
    async mixDescargarImagen(data) {
      this.mostrarDescargando = true;
      await this.axios.get(
        `${BASE_URL}/${data.publicKey}`,
        {
          responseType: 'blob',
          onDownloadProgress: (progressEvent) => {
            if (progressEvent.lengthComputable) {
              this.progresoDescarga = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total,
              );
            }
          },
        },
      )
        .then((res) => {
          fileDownload(res.data,
            `${data.nombreArchivo}.jpg`);
        })
        .catch((err) => {
          this.mixMensajeError(err.data.message);
        });
      this.mostrarDescargando = false;

      this.progresoDescarga = null;
    },
    async mixDescargaImagenesZip(data) {
      this.mostrarDescargando = true;
      await this.axios({
        method: 'POST',
        url: `${BASE_URL}/generarZip`,
        responseType: 'blob',
        data: {
          nombreDocumento: data.nombreArchivo,
          keys: data.SoloPublicKeys,
        },
        onDownloadProgress: (progressEvent) => {
          if (progressEvent.lengthComputable) {
            this.progresoDescarga = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total,
            );
          }
        },
      })
        .then((res) => {
          fileDownload(res.data, `${data.nombreArchivo}.zip`);
        })
        .catch((err) => {
          this.mixMensajeError(err.data.message);
        });
      this.mostrarDescargando = false;
      this.progresoDescarga = null;
    },
  },
};
